<!--
 * @Autor: 可爱又迷人的反派角色
 * @Version: 3.0
 * @Date: 2021-09-23 13:08:40
 * @LastEditTime: 2021-09-26 09:11:09
 * @FilePath: \wechat_ticketing3.0\src\components\FieldOptionCustomerInfoGroup.vue
 * @Description: 
-->
<template>
  <div class="field-option-customer-info-group-wrapper">
    <field-option-customer-info
      v-for="(item, index) of items"
      :key="index"
      :shapes="shapes"
      @change="$event => handleFieldChange(index, $event)"
      @handleId="handleId"
    />
  </div>
</template>
<script>
import FieldOptionCustomerInfo from './FieldOptionCustomerInfo.vue';

export default {
  data() {
    return {
      idValue: 0,
    };
  },
  components: {
    FieldOptionCustomerInfo,
  },
  props: {
    items: [Array],
    shapes: [Array],
  },
  methods: {
    handleId(idValue) {
      this.idValue = idValue;

      this.$emit('handleId', this.idValue);
    },
    handleFieldChange(index, item) {
      const items = this.items.map((innerItem, innerIndex) =>
        index === innerIndex ? item : innerItem
      );
      this.$emit('change', items);
    },
  },
};
</script>
<style lang="less" scoped></style>
